import React from "react"
import { Link } from "gatsby"
import { Helmet } from "react-helmet"

import Layout from "../../components/Layout"
import DestinationListingsPreview from "../../components/destination/ListingsPreviewSlot"

const SITE_URL = "https://gadait-international.com"
const DEFAULT_HERO_IMAGE =
  "https://www.datocms-assets.com/33658/1769357384-luxury-villa-marbella-gadait-international.jpg"

const imageUrl = (url, params) => `${url}${url.includes("?") ? "&" : "?"}${params}`

const AREA_VISUALS = {
  goldenMile: {
    hero:
      "https://www.datocms-assets.com/33658/1770388128-sv1613_23225043.jpg",
    heroAlt: {
      fr: "Villa contemporaine proche Golden Mile a Marbella",
      en: "Contemporary villa near Marbella Golden Mile",
    },
    gallery: [
      {
        image:
          "https://www.datocms-assets.com/33658/1770388161-sv1613_23224912.jpg",
        fr: {
          eyebrow: "Beachside",
          title: "Proximite mer et services",
          text: "La Golden Mile se juge par l'acces reel a pied, le calme et la qualite de l'environnement immediat.",
        },
        en: {
          eyebrow: "Beachside",
          title: "Beach and service proximity",
          text: "The Golden Mile is assessed by real walkability, calm and immediate surroundings.",
        },
      },
      {
        image:
          "https://www.datocms-assets.com/33658/1770388196-sv1613_23224972.jpg",
        fr: {
          eyebrow: "Architecture",
          title: "Rareté des villas finies",
          text: "Les biens les plus liquides combinent parcelle utilisable, finition defendable et adresse lisible.",
        },
        en: {
          eyebrow: "Architecture",
          title: "Scarcity of finished villas",
          text: "The most liquid assets combine usable land, defensible finish and a clear address.",
        },
      },
      {
        image:
          "https://www.datocms-assets.com/33658/1774435892-sv1613_23802227.jpg",
        fr: {
          eyebrow: "Lifestyle",
          title: "Usage quotidien",
          text: "Terrasses, vues et intimite comptent autant que la distance brute a Puente Romano ou Marbella Club.",
        },
        en: {
          eyebrow: "Lifestyle",
          title: "Everyday use",
          text: "Terraces, views and privacy matter as much as raw distance to Puente Romano or Marbella Club.",
        },
      },
    ],
  },
  nuevaAndalucia: {
    hero:
      "https://www.datocms-assets.com/33658/1774792787-sv2315_22004149-large.jpg",
    heroAlt: {
      fr: "Villa avec jardin et piscine a Nueva Andalucia",
      en: "Villa with garden and pool in Nueva Andalucia",
    },
    gallery: [
      {
        image:
          "https://www.datocms-assets.com/33658/1774792799-sv2315_22043683-large.jpg",
        fr: {
          eyebrow: "Golf Valley",
          title: "Villas familiales et golf",
          text: "Aloha, Las Brisas et Los Naranjos creent une demande profonde pour les villas faciles a vivre.",
        },
        en: {
          eyebrow: "Golf Valley",
          title: "Family villas and golf",
          text: "Aloha, Las Brisas and Los Naranjos create deep demand for practical family villas.",
        },
      },
      {
        image:
          "https://www.datocms-assets.com/33658/1774792823-sv2315_22043645-large.jpg",
        fr: {
          eyebrow: "Outdoor",
          title: "Jardins et reception",
          text: "Le potentiel locatif depend beaucoup des espaces exterieurs, du stationnement et de l'intimite.",
        },
        en: {
          eyebrow: "Outdoor",
          title: "Gardens and entertaining",
          text: "Rental strength depends heavily on outdoor areas, parking and privacy.",
        },
      },
      {
        image:
          "https://www.datocms-assets.com/33658/1774793172-sv2315_22043691-large.jpg",
        fr: {
          eyebrow: "Emplacement",
          title: "Proximite Puerto Banus",
          text: "Nueva Andalucia fonctionne quand les services, les ecoles et la marina restent dans un rayon court.",
        },
        en: {
          eyebrow: "Location",
          title: "Puerto Banus proximity",
          text: "Nueva Andalucia works when services, schools and the marina remain within a short radius.",
        },
      },
    ],
  },
  laZagaleta: {
    hero:
      "https://www.datocms-assets.com/33658/1728705661-project-phase3.jpg",
    heroAlt: {
      fr: "Domaine prive dans les collines de Benahavis pres de Marbella",
      en: "Private estate in the Benahavis hills near Marbella",
    },
    gallery: [
      {
        image:
          "https://www.datocms-assets.com/33658/1728706253-marbellaclubhills0024.jpg",
        fr: {
          eyebrow: "Altitude",
          title: "Vues longues et discretion",
          text: "Sur le segment ultra-prime, le terrain et l'orientation expliquent une grande partie de la valeur.",
        },
        en: {
          eyebrow: "Elevation",
          title: "Long views and discretion",
          text: "In the ultra-prime segment, land and orientation explain a large part of value.",
        },
      },
      {
        image:
          "https://www.datocms-assets.com/33658/1728706254-15_pareados_hd_terraza_v3.jpg",
        fr: {
          eyebrow: "Terrasses",
          title: "Vie interieure-exterieure",
          text: "La qualite d'usage depend des terrasses, du soleil, du vent et de la protection des vues.",
        },
        en: {
          eyebrow: "Terraces",
          title: "Indoor-outdoor living",
          text: "Usability depends on terraces, sun, wind exposure and protected views.",
        },
      },
      {
        image:
          "https://www.datocms-assets.com/33658/1775273350-sv2469_23292710-large.jpg",
        fr: {
          eyebrow: "Ultra-prime",
          title: "Architecture et intimite",
          text: "La Zagaleta se compare par confidentialite, echelle fonciere et cout d'usage, pas par plage.",
        },
        en: {
          eyebrow: "Ultra-prime",
          title: "Architecture and privacy",
          text: "La Zagaleta is compared by privacy, land scale and running cost, not by beach access.",
        },
      },
    ],
  },
  sierraBlanca: {
    hero:
      "https://www.datocms-assets.com/33658/1771327944-villa-luxury-marbella-gi0393-photo-1.jpg",
    heroAlt: {
      fr: "Villa de luxe a Sierra Blanca avec vues mer",
      en: "Luxury villa in Sierra Blanca with sea views",
    },
    gallery: [
      {
        image:
          "https://www.datocms-assets.com/33658/1771328033-villa-luxury-marbella-gi0436-photo-1.jpg",
        fr: {
          eyebrow: "Vues",
          title: "Altitude et panorama",
          text: "Sierra Blanca se valorise par la qualite de vue, sa protection et le confort d'acces.",
        },
        en: {
          eyebrow: "Views",
          title: "Elevation and panorama",
          text: "Sierra Blanca is valued by view quality, view protection and access comfort.",
        },
      },
      {
        image:
          "https://www.datocms-assets.com/33658/1771328071-villa-luxury-marbella-gi0436-photo-22.jpg",
        fr: {
          eyebrow: "Residentiel",
          title: "Calme et securite",
          text: "Le secteur attire les familles qui veulent Marbella sans l'intensite des zones plage.",
        },
        en: {
          eyebrow: "Residential",
          title: "Calm and security",
          text: "The area attracts families who want Marbella without the intensity of beach districts.",
        },
      },
      {
        image:
          "https://www.datocms-assets.com/33658/1771327952-villa-luxury-marbella-gi0393-photo-8.jpg",
        fr: {
          eyebrow: "Interieurs",
          title: "Qualite technique",
          text: "Isolation, renovation, maintenance et charges communautaires doivent etre verifies avant offre.",
        },
        en: {
          eyebrow: "Interiors",
          title: "Technical quality",
          text: "Insulation, renovation, maintenance and community fees must be verified before an offer.",
        },
      },
    ],
  },
}

export const MARBELLA_AREA_PAGES = {
  goldenMile: {
    fr: {
      slug: "villa-golden-mile-marbella",
      title: "Villas Golden Mile Marbella",
      seoTitle:
        "Villas Golden Mile Marbella à vendre | Plage, rareté & off-market",
      seoDescription:
        "Villas Golden Mile Marbella à vendre: adresses plage, Puente Romano, rareté foncière, biens off-market et shortlist privée GADAIT.",
      eyebrow: "Marbella · Golden Mile",
      intro:
        "La Golden Mile reste l'adresse la plus patrimoniale de Marbella pour les acheteurs qui recherchent plage, services premium, discretion et profondeur de revente.",
      sections: [
        {
          title: "Pourquoi viser la Golden Mile",
          text: "Cette zone concentre les actifs les plus lisibles de la Costa del Sol: villas proches de la plage, hotels iconiques, beach clubs et acces rapide a Puerto Banus comme au centre de Marbella. La rarete y soutient la liquidite.",
        },
        {
          title: "Ce que nous verifions",
          text: "Nous analysons la distance reelle a la mer, la confidentialite, la conformite urbanistique, le niveau de nuisance, la qualite de parcelle et la coherence du prix face aux comparables recents.",
        },
      ],
      bullets: [
        "Villas plage et adresses iconiques",
        "Liquidite forte sur actifs prime",
        "Demande internationale durable",
        "Selection off-market possible",
      ],
      listingTitle: "Sélection de villas Golden Mile et Marbella",
      listingIntro:
        "9 biens à comparer en priorité: Golden Mile quand l'inventaire le permet, puis les meilleures alternatives Marbella pour garder une vraie profondeur de choix.",
      listingKeywords: ["golden mile", "puente romano", "nagueles"],
      listingSearchQuery: "Golden Mile",
      cta: "Recevoir une shortlist Golden Mile",
      searchLabel: "Voir les villas a Marbella",
      allListingsLabel: "Voir toutes les villas Golden Mile / Marbella →",
      hubLabel: "Retour aux proprietes Marbella",
    },
    en: {
      slug: "golden-mile-marbella-villas",
      title: "Golden Mile Marbella villas for sale",
      seoTitle:
        "Golden Mile Marbella Villas for Sale | Beachside & Off-Market Homes",
      seoDescription:
        "Golden Mile Marbella villas for sale: beachside homes, Puente Romano addresses, scarce plots, off-market access and a private GADAIT shortlist.",
      eyebrow: "Marbella · Golden Mile",
      intro:
        "The Golden Mile remains Marbella's most patrimonial address for buyers seeking beach proximity, premium services, discretion and deep resale demand.",
      sections: [
        {
          title: "Why target the Golden Mile",
          text: "This corridor concentrates the Costa del Sol's clearest prime assets: beachside villas, iconic hotels, beach clubs and fast access to both Puerto Banus and Marbella old town. Scarcity supports liquidity.",
        },
        {
          title: "What we verify",
          text: "We review real beach access, privacy, urban compliance, noise exposure, plot quality and pricing coherence against recent comparable transactions.",
        },
      ],
      bullets: [
        "Beachside villas and iconic addresses",
        "Strong liquidity on prime assets",
        "Durable international demand",
        "Off-market access when relevant",
      ],
      listingTitle: "Golden Mile and Marbella villa selection",
      listingIntro:
        "9 properties to compare first: Golden Mile when inventory allows, then the strongest Marbella alternatives to keep real choice depth.",
      listingKeywords: ["golden mile", "puente romano", "nagueles"],
      listingSearchQuery: "Golden Mile",
      cta: "Receive a Golden Mile shortlist",
      searchLabel: "View Marbella villas",
      allListingsLabel: "View all Golden Mile / Marbella villas →",
      hubLabel: "Back to Marbella properties",
    },
  },
  nuevaAndalucia: {
    fr: {
      slug: "villa-nueva-andalucia-marbella",
      title: "Villas Nueva Andalucia Marbella",
      seoTitle:
        "Villas Nueva Andalucía Marbella à vendre | Golf Valley & off-market",
      seoDescription:
        "Villas à vendre à Nueva Andalucía, Marbella Golf Valley: Aloha, Las Brisas, vues golf, biens familiaux et shortlist privée GADAIT.",
      eyebrow: "Marbella · Nueva Andalucia",
      intro:
        "Nueva Andalucia offre l'un des meilleurs equilibres de Marbella entre golf, vie familiale, restaurants, ecoles internationales et profondeur de marche.",
      sections: [
        {
          title: "Un marche golf et familial",
          text: "Aloha, Las Brisas et Los Naranjos structurent une demande solide pour les villas contemporaines, les maisons familiales et les proprietes avec vues ouvertes.",
        },
        {
          title: "Notre lecture d'acquisition",
          text: "Nous privilegions les rues calmes, les orientations coherentes, la qualite de renovation, l'acces aux services et la capacite du bien a rester liquide a la revente.",
        },
      ],
      bullets: [
        "Golf Valley et vie familiale",
        "Bon compromis usage/rendement",
        "Forte demande saisonniere",
        "Acces rapide Puerto Banus",
      ],
      listingTitle: "Sélection de villas Nueva Andalucia",
      listingIntro:
        "9 biens à comparer autour de Nueva Andalucia, Golf Valley et Marbella, avec priorité aux actifs les plus cohérents pour un usage familial ou lifestyle.",
      listingKeywords: ["nueva andalucia", "aloha", "las brisas", "los naranjos", "golf valley"],
      listingSearchQuery: "Nueva Andalucia",
      cta: "Recevoir une shortlist Nueva Andalucia",
      searchLabel: "Voir les villas a Marbella",
      allListingsLabel: "Voir toutes les villas Nueva Andalucia / Marbella →",
      hubLabel: "Retour aux proprietes Marbella",
    },
    en: {
      slug: "nueva-andalucia-marbella-villas",
      title: "Nueva Andalucia Marbella villas for sale",
      seoTitle:
        "Nueva Andalucia Marbella Villas for Sale | Golf Valley & Off-Market",
      seoDescription:
        "Nueva Andalucia Marbella villas for sale in Golf Valley: Aloha, Las Brisas, family homes, golf views and private GADAIT shortlist.",
      eyebrow: "Marbella · Nueva Andalucia",
      intro:
        "Nueva Andalucia offers one of Marbella's strongest balances between golf, family living, restaurants, international schools and market depth.",
      sections: [
        {
          title: "A golf and family-led market",
          text: "Aloha, Las Brisas and Los Naranjos support resilient demand for contemporary villas, family homes and properties with open views.",
        },
        {
          title: "Our acquisition lens",
          text: "We prioritize quiet streets, coherent orientation, renovation quality, service access and the asset's ability to remain liquid on resale.",
        },
      ],
      bullets: [
        "Golf Valley and family lifestyle",
        "Strong usage/yield balance",
        "High seasonal demand",
        "Fast access to Puerto Banus",
      ],
      listingTitle: "Nueva Andalucia villa selection",
      listingIntro:
        "9 properties to compare around Nueva Andalucia, Golf Valley and Marbella, prioritising coherent family and lifestyle assets.",
      listingKeywords: ["nueva andalucia", "aloha", "las brisas", "los naranjos", "golf valley"],
      listingSearchQuery: "Nueva Andalucia",
      cta: "Receive a Nueva Andalucia shortlist",
      searchLabel: "View Marbella villas",
      allListingsLabel: "View all Nueva Andalucia / Marbella villas →",
      hubLabel: "Back to Marbella properties",
    },
  },
  laZagaleta: {
    fr: {
      slug: "villa-la-zagaleta-marbella",
      title: "Villas La Zagaleta près de Marbella",
      seoTitle:
        "Villas La Zagaleta près de Marbella | Ultra-prime & off-market",
      seoDescription:
        "Villas ultra-prime à La Zagaleta près de Marbella: sécurité, grands terrains, vues, confidentialité et sourcing off-market GADAIT.",
      eyebrow: "Marbella · La Zagaleta",
      intro:
        "La Zagaleta s'adresse aux acheteurs qui placent la confidentialite, la securite et l'echelle fonciere au-dessus de la simple proximite plage.",
      sections: [
        {
          title: "Le segment ultra-prime",
          text: "L'estate offre de grands terrains, une securite renforcee, des vues panoramiques et un niveau de discretion rare en Europe du Sud.",
        },
        {
          title: "Due diligence specifique",
          text: "Nous etudions acces, gouvernance, charges, maintenance, vues preservees, potentiel architectural et coherence du prix dans un marche peu transparent.",
        },
      ],
      bullets: [
        "Securite et discretion maximales",
        "Grands terrains et vues ouvertes",
        "Marche ultra-prime rare",
        "Sourcing confidentiel indispensable",
      ],
      listingTitle: "Sélection de villas La Zagaleta et Benahavis",
      listingIntro:
        "9 biens à comparer sur le segment ultra-prime: La Zagaleta quand disponible, puis les alternatives Benahavis/Marbella les plus pertinentes.",
      listingKeywords: ["zagaleta", "benahavis", "benahavís", "el madronal"],
      listingSearchQuery: "La Zagaleta",
      cta: "Recevoir une shortlist La Zagaleta",
      searchLabel: "Voir les villas a Marbella",
      allListingsLabel: "Voir toutes les villas La Zagaleta / Marbella →",
      hubLabel: "Retour aux proprietes Marbella",
    },
    en: {
      slug: "la-zagaleta-marbella-villas",
      title: "La Zagaleta villas near Marbella",
      seoTitle:
        "La Zagaleta Villas near Marbella | Ultra-Prime & Off-Market Access",
      seoDescription:
        "La Zagaleta villas near Marbella: ultra-prime estates with security, large plots, views, discretion and confidential GADAIT sourcing.",
      eyebrow: "Marbella · La Zagaleta",
      intro:
        "La Zagaleta is built for buyers who value privacy, security and land scale above simple beach proximity.",
      sections: [
        {
          title: "The ultra-prime segment",
          text: "The estate offers large plots, reinforced security, panoramic views and a level of discretion rarely available in Southern Europe.",
        },
        {
          title: "Specific due diligence",
          text: "We review access, governance, fees, maintenance, protected views, architectural potential and pricing coherence in a low-transparency market.",
        },
      ],
      bullets: [
        "Maximum security and discretion",
        "Large plots and open views",
        "Rare ultra-prime market",
        "Confidential sourcing required",
      ],
      listingTitle: "La Zagaleta and Benahavis villa selection",
      listingIntro:
        "9 properties to compare in the ultra-prime segment: La Zagaleta when available, then the most relevant Benahavis/Marbella alternatives.",
      listingKeywords: ["zagaleta", "benahavis", "benahavís", "el madronal"],
      listingSearchQuery: "La Zagaleta",
      cta: "Receive a La Zagaleta shortlist",
      searchLabel: "View Marbella villas",
      allListingsLabel: "View all La Zagaleta / Marbella villas →",
      hubLabel: "Back to Marbella properties",
    },
  },
  sierraBlanca: {
    fr: {
      slug: "villa-sierra-blanca-marbella",
      title: "Villas Sierra Blanca Marbella",
      seoTitle:
        "Villas Sierra Blanca Marbella à vendre | Vues mer & sécurité",
      seoDescription:
        "Villas à vendre à Sierra Blanca Marbella: vues mer, communautés sécurisées, grandes parcelles et shortlist privée GADAIT.",
      eyebrow: "Marbella · Sierra Blanca",
      intro:
        "Sierra Blanca combine altitude, vues mer, securite et proximite rapide avec Marbella, ce qui en fait un secteur fort pour les familles internationales.",
      sections: [
        {
          title: "Vues et securite",
          text: "Le secteur attire les acheteurs qui veulent une adresse residentielle securisee, des vues ouvertes et une experience plus calme que les zones tres proches plage.",
        },
        {
          title: "Points de vigilance",
          text: "Nous verifions orientation, exposition au vent, qualite d'acces, charges, niveau de renovation et capacite de revente face aux alternatives Golden Mile et Nueva Andalucia.",
        },
      ],
      bullets: [
        "Vues mer et montagne",
        "Communautes securisees",
        "Adresse familiale prime",
        "Acces rapide au centre",
      ],
      listingTitle: "Sélection de villas Sierra Blanca",
      listingIntro:
        "9 biens à comparer autour de Sierra Blanca, Nagueles et Marbella, avec priorité aux vues, à la sécurité et à la profondeur de revente.",
      listingKeywords: ["sierra blanca", "nagueles", "nagüeles", "cascada de camojan", "camojan"],
      listingSearchQuery: "Sierra Blanca",
      cta: "Recevoir une shortlist Sierra Blanca",
      searchLabel: "Voir les villas a Marbella",
      allListingsLabel: "Voir toutes les villas Sierra Blanca / Marbella →",
      hubLabel: "Retour aux proprietes Marbella",
    },
    en: {
      slug: "sierra-blanca-marbella-villas",
      title: "Sierra Blanca Marbella villas for sale",
      seoTitle:
        "Sierra Blanca Marbella Villas for Sale | Sea Views & Gated Estates",
      seoDescription:
        "Sierra Blanca Marbella villas for sale: sea views, gated communities, large plots, prime family homes and GADAIT acquisition advisory.",
      eyebrow: "Marbella · Sierra Blanca",
      intro:
        "Sierra Blanca combines elevation, sea views, security and fast access to Marbella, making it a strong district for international families.",
      sections: [
        {
          title: "Views and security",
          text: "The area attracts buyers seeking a secure residential address, open outlooks and a calmer ownership experience than the most beach-proximate zones.",
        },
        {
          title: "Points to verify",
          text: "We review orientation, wind exposure, access quality, fees, renovation level and resale strength against Golden Mile and Nueva Andalucia alternatives.",
        },
      ],
      bullets: [
        "Sea and mountain views",
        "Gated communities",
        "Prime family address",
        "Fast access to central Marbella",
      ],
      listingTitle: "Sierra Blanca villa selection",
      listingIntro:
        "9 properties to compare around Sierra Blanca, Nagueles and Marbella, prioritising views, security and resale depth.",
      listingKeywords: ["sierra blanca", "nagueles", "nagüeles", "cascada de camojan", "camojan"],
      listingSearchQuery: "Sierra Blanca",
      cta: "Receive a Sierra Blanca shortlist",
      searchLabel: "View Marbella villas",
      allListingsLabel: "View all Sierra Blanca / Marbella villas →",
      hubLabel: "Back to Marbella properties",
    },
  },
}

const EXPERT_CONTENT = {
  goldenMile: {
    fr: {
      positioning:
        "Acheter sur la Golden Mile ne consiste pas simplement a payer l'adresse la plus connue de Marbella. Il faut distinguer les biens reellement proches de la mer, les villas situees cote montagne, les actifs a renover, les maisons recentes avec architecture internationale et les proprietes dont la valeur repose surtout sur la taille de parcelle. Deux villas separees de quelques rues peuvent avoir une liquidite, une intimite et une profondeur de demande tres differentes.",
      marketSignals: [
        {
          label: "Prime beachside",
          text: "Les biens les plus recherches combinent acces plage, faible nuisance, parcelle exploitable et services a proximite. La rarete est forte, mais la discipline de prix reste essentielle.",
        },
        {
          label: "Cote montagne",
          text: "Les villas au-dessus de l'A-7 peuvent offrir plus de surface et de vues. L'analyse doit integrer le bruit, l'acces, l'orientation et la perception de l'adresse.",
        },
        {
          label: "Revente",
          text: "La liquidite depend de la coherence entre emplacement exact, etat technique, style architectural et prix par rapport aux transactions recentes.",
        },
      ],
      buyerProfiles: [
        "Residence principale ou secondaire avec acces rapide aux plages, hotels et restaurants.",
        "Famille internationale qui veut Marbella centre, Puente Romano, Puerto Banus et les ecoles dans un rayon court.",
        "Acheteur patrimonial qui privilegie la rarete fonciere et la revente a long terme.",
      ],
      propertyTypes: [
        "Villas contemporaines cle en main avec suites independantes, spa, piscine et garage ferme.",
        "Maisons a renover sur parcelles rares, interessantes si le prix laisse une marge travaux realiste.",
        "Villas proches Puente Romano pour un usage lifestyle intensif et une forte demande locative saisonniere.",
      ],
      dueDiligence: [
        "Titre, permis, metres construits declares et conformite des extensions.",
        "Nuisances sonores, vis-a-vis, acces reel a pied et exposition au trafic.",
        "Qualite structurelle, humidite, climatisation, domotique et couts de remise a niveau.",
        "Comparables recents, marge de negociation et liquidite probable en sortie.",
      ],
    },
    en: {
      positioning:
        "Buying on the Golden Mile is not just about paying for Marbella's best-known address. The right analysis separates true beach-proximity assets, mountainside villas, renovation opportunities, recently built international-style homes and properties whose value is mainly driven by plot scarcity. Two villas only a few streets apart can have very different liquidity, privacy and depth of demand.",
      marketSignals: [
        {
          label: "Prime beachside",
          text: "The strongest assets combine beach access, low nuisance, usable plot size and nearby services. Scarcity is high, but price discipline still matters.",
        },
        {
          label: "Mountainside",
          text: "Villas above the A-7 can offer more volume and views. Noise, access, orientation and address perception must be priced correctly.",
        },
        {
          label: "Resale depth",
          text: "Liquidity depends on the exact location, technical condition, architectural language and pricing against recent transactions.",
        },
      ],
      buyerProfiles: [
        "Primary or secondary-home buyers seeking fast access to beaches, hotels and restaurants.",
        "International families wanting Marbella centre, Puente Romano, Puerto Banus and schools within a short radius.",
        "Patrimonial buyers prioritising land scarcity and long-term resale strength.",
      ],
      propertyTypes: [
        "Turnkey contemporary villas with independent suites, spa, pool and closed garage.",
        "Renovation-led houses on rare plots, attractive only when the price leaves a realistic works margin.",
        "Puente Romano-proximate villas for intensive lifestyle use and strong seasonal rental demand.",
      ],
      dueDiligence: [
        "Title, permits, declared built area and compliance of extensions.",
        "Noise, overlooking, real walkability and traffic exposure.",
        "Structure, humidity, air conditioning, home automation and upgrade costs.",
        "Recent comparables, negotiation margin and probable exit liquidity.",
      ],
    },
  },
  nuevaAndalucia: {
    fr: {
      positioning:
        "Nueva Andalucia est un marche plus vaste et plus nuance que son image de Golf Valley. Les meilleures acquisitions combinent calme residentiel, acces rapide a Puerto Banus, proximite des golfs et plan de villa adapte a un usage familial. La profondeur de demande est forte, mais la qualite varie fortement d'une rue a l'autre.",
      marketSignals: [
        {
          label: "Golf Valley",
          text: "Aloha, Las Brisas et Los Naranjos creent une demande lisible pour les villas avec vues ouvertes, jardins matures et acces club.",
        },
        {
          label: "Usage familial",
          text: "La demande internationale privilegie les suites nombreuses, les espaces exterieurs utilisables, le stationnement et la proximite des ecoles.",
        },
        {
          label: "Rendement",
          text: "Le secteur peut offrir un meilleur equilibre usage personnel/location saisonniere que les adresses ultra-prime, sous reserve de reglementation et gestion.",
        },
      ],
      buyerProfiles: [
        "Familles cherchant un quotidien pratique entre golf, ecoles, restaurants et marina.",
        "Investisseurs lifestyle recherchant une occupation personnelle et un potentiel locatif.",
        "Acheteurs qui veulent plus de surface que Golden Mile a budget comparable.",
      ],
      propertyTypes: [
        "Villas familiales renovees avec jardin plat, piscine et cinq chambres ou plus.",
        "Maisons contemporaines avec vues golf ou montagne, bien placees pour la location premium.",
        "Actifs a moderniser dans les rues calmes, a condition de maitriser couts et delais travaux.",
      ],
      dueDiligence: [
        "Regime communautaire, charges, regles de location et voisinage.",
        "Orientation, bruit routier, declivite de parcelle et qualite d'acces.",
        "Historique locatif, saisonnalite et cout de gestion realiste.",
        "Comparaison prix/m2 avec etat reel, vues et qualite de renovation.",
      ],
    },
    en: {
      positioning:
        "Nueva Andalucia is broader and more nuanced than its Golf Valley image suggests. The best acquisitions combine residential calm, fast Puerto Banus access, golf proximity and a villa layout suited to family use. Demand depth is strong, but quality varies materially from one street to another.",
      marketSignals: [
        {
          label: "Golf Valley",
          text: "Aloha, Las Brisas and Los Naranjos create clear demand for villas with open views, mature gardens and club access.",
        },
        {
          label: "Family use",
          text: "International buyers prioritise multiple suites, usable outdoor areas, parking and proximity to schools.",
        },
        {
          label: "Yield balance",
          text: "The area can offer a better personal-use and seasonal-rental balance than ultra-prime addresses, subject to rules and management.",
        },
      ],
      buyerProfiles: [
        "Families seeking a practical daily base between golf, schools, restaurants and the marina.",
        "Lifestyle investors wanting personal occupancy with rental potential.",
        "Buyers looking for more surface area than the Golden Mile at a comparable budget.",
      ],
      propertyTypes: [
        "Renovated family villas with flat gardens, pools and five bedrooms or more.",
        "Contemporary houses with golf or mountain views, well positioned for premium rentals.",
        "Modernisation assets on quiet streets, provided works costs and timing are controlled.",
      ],
      dueDiligence: [
        "Community regime, fees, rental rules and neighbouring properties.",
        "Orientation, road noise, plot slope and access quality.",
        "Rental history, seasonality and realistic management costs.",
        "Price per square metre against real condition, views and renovation quality.",
      ],
    },
  },
  laZagaleta: {
    fr: {
      positioning:
        "La Zagaleta est un marche de conviction, peu comparable aux quartiers classiques de Marbella. La valeur repose sur la securite, la confidentialite, la taille fonciere, les vues, l'architecture et la rarete de l'offre. Les comparables publics sont limites: l'acquisition exige une lecture privee du marche et une due diligence beaucoup plus granulaire.",
      marketSignals: [
        {
          label: "Confidentialite",
          text: "L'offre visible ne represente qu'une partie du marche. Les meilleures opportunites circulent souvent via reseaux prives.",
        },
        {
          label: "Echelle fonciere",
          text: "La taille de parcelle, la topographie, les vues preservees et le potentiel architectural expliquent les ecarts de valeur.",
        },
        {
          label: "Cout d'usage",
          text: "Maintenance, securite, personnel, jardins, energie et charges doivent etre integres avant toute decision.",
        },
      ],
      buyerProfiles: [
        "Ultra-high-net-worth buyers recherchant discretion, controle d'acces et grands volumes.",
        "Familles qui veulent un domaine prive plus qu'une adresse plage.",
        "Acheteurs internationaux comparant Marbella a la Cote d'Azur, Majorque, Suisse ou Londres.",
      ],
      propertyTypes: [
        "Domaines contemporains avec vues panoramiques, wellness, cinema, staff quarters et garage collection.",
        "Villas classiques sur tres grandes parcelles offrant un potentiel de repositionnement.",
        "Actifs off-market dont la valeur depend de conditions de transaction confidentielles.",
      ],
      dueDiligence: [
        "Gouvernance de la communaute, charges, securite et droits associes.",
        "Permis, potentiel constructible, servitudes et contraintes paysageres.",
        "Etat des systemes techniques: energie, eau, climatisation, ascenseurs, domotique.",
        "Prix net vendeur, historique discret du bien et profondeur reelle de revente.",
      ],
    },
    en: {
      positioning:
        "La Zagaleta is a conviction market, not directly comparable with standard Marbella districts. Value is driven by security, privacy, land scale, views, architecture and supply scarcity. Public comparables are limited: acquisition requires a private market read and far more granular due diligence.",
      marketSignals: [
        {
          label: "Confidentiality",
          text: "Visible listings only represent part of the market. The strongest opportunities often circulate through private networks.",
        },
        {
          label: "Land scale",
          text: "Plot size, topography, protected views and architectural potential explain large value gaps.",
        },
        {
          label: "Running cost",
          text: "Maintenance, security, staff, gardens, energy and community fees must be modelled before any decision.",
        },
      ],
      buyerProfiles: [
        "Ultra-high-net-worth buyers seeking discretion, controlled access and large volumes.",
        "Families wanting a private estate more than a beach address.",
        "International buyers benchmarking Marbella against the French Riviera, Mallorca, Switzerland or London.",
      ],
      propertyTypes: [
        "Contemporary estates with panoramic views, wellness, cinema, staff quarters and collection garages.",
        "Classic villas on very large plots with repositioning potential.",
        "Off-market assets whose value depends on confidential transaction conditions.",
      ],
      dueDiligence: [
        "Community governance, fees, security and associated rights.",
        "Permits, buildability, easements and landscape constraints.",
        "Technical systems: energy, water, air conditioning, lifts and home automation.",
        "Net vendor price, discreet property history and real resale depth.",
      ],
    },
  },
  sierraBlanca: {
    fr: {
      positioning:
        "Sierra Blanca attire les acheteurs qui veulent une adresse residentielle securisee, des vues mer et une proximite rapide avec Marbella sans etre dans l'intensite des zones plage. L'altitude est un atout, mais elle impose une analyse fine de l'orientation, de l'exposition au vent, de l'acces et de la qualite de construction.",
      marketSignals: [
        {
          label: "Adresse familiale",
          text: "Le secteur est pertinent pour les familles internationales qui recherchent calme, securite et acces rapide au centre.",
        },
        {
          label: "Vues",
          text: "La qualite de vue mer/montagne, sa protection et son angle reel depuis les pieces de vie impactent fortement la valeur.",
        },
        {
          label: "Comparaison prime",
          text: "L'arbitrage se fait souvent face a Golden Mile et Nueva Andalucia: surface, securite et vues contre proximite plage.",
        },
      ],
      buyerProfiles: [
        "Familles recherchant securite, volumes et environnement residentiel calme.",
        "Acheteurs voulant des vues mer sans renoncer a Marbella centre.",
        "Clients qui privilegient une residence principale ou semi-principale plutot qu'un produit locatif pur.",
      ],
      propertyTypes: [
        "Villas contemporaines en communaute securisee avec vues mer et espaces wellness.",
        "Grandes maisons familiales avec jardin, suites invites et espaces de service.",
        "Actifs a renover lorsque l'adresse, la vue et la parcelle justifient le repositionnement.",
      ],
      dueDiligence: [
        "Orientation, ensoleillement, exposition au vent et confort thermique.",
        "Charges communautaires, securite, acces et entretien des parties communes.",
        "Qualite de renovation, isolation, systemes techniques et cout de maintenance.",
        "Positionnement de prix face a Golden Mile, Nagueles et Nueva Andalucia.",
      ],
    },
    en: {
      positioning:
        "Sierra Blanca attracts buyers seeking a secure residential address, sea views and fast Marbella access without the intensity of beach districts. Elevation is an advantage, but it requires careful analysis of orientation, wind exposure, access and construction quality.",
      marketSignals: [
        {
          label: "Family address",
          text: "The area suits international families looking for calm, security and fast access to the centre.",
        },
        {
          label: "Views",
          text: "The quality of sea and mountain views, their protection and the actual angle from living areas strongly affect value.",
        },
        {
          label: "Prime comparison",
          text: "The trade-off is often against Golden Mile and Nueva Andalucia: surface, security and views versus beach proximity.",
        },
      ],
      buyerProfiles: [
        "Families seeking security, volume and a calm residential environment.",
        "Buyers wanting sea views without giving up Marbella centre access.",
        "Clients prioritising a primary or semi-primary residence over a pure rental product.",
      ],
      propertyTypes: [
        "Contemporary gated-community villas with sea views and wellness areas.",
        "Large family homes with gardens, guest suites and service areas.",
        "Renovation assets where address, view and plot justify repositioning.",
      ],
      dueDiligence: [
        "Orientation, sunlight, wind exposure and thermal comfort.",
        "Community fees, security, access and maintenance of common areas.",
        "Renovation quality, insulation, technical systems and maintenance costs.",
        "Pricing against Golden Mile, Nagueles and Nueva Andalucia.",
      ],
    },
  },
}

const SHARED_EXPERT_CONTENT = {
  fr: {
    advisoryTitle: "Comment GADAIT structure votre acquisition",
    advisoryIntro:
      "Notre role n'est pas de multiplier les visites. Nous qualifions le marche, eliminons les actifs incoherents et construisons une shortlist defendable sur le plan patrimonial, technique et transactionnel.",
    advisorySteps: [
      "Cadrage du budget, de l'usage, de la fiscalite et du niveau de discretion souhaite.",
      "Cartographie des secteurs, rues, micro-nuisances et niveaux de prix defendables.",
      "Sourcing public, reseau prive et verification des biens off-market quand ils existent.",
      "Analyse comparative, due diligence initiale, strategie d'offre et accompagnement jusqu'a la signature.",
    ],
    faqTitle: "Questions frequentes",
    faq: [
      {
        question: "Quel budget prevoir pour une villa prime a Marbella ?",
        answer:
          "Le budget depend fortement du secteur, de la proximite mer, de la taille de parcelle, de l'etat technique et de la rarete de l'adresse. Deux biens affiches au meme prix peuvent avoir des profils de risque tres differents.",
      },
      {
        question: "Faut-il acheter cle en main ou renover ?",
        answer:
          "Le cle en main reduit le risque d'execution mais integre souvent une prime. La renovation peut creer de la valeur si le foncier, les permis, les couts travaux et le calendrier sont maitrises avant l'offre.",
      },
      {
        question: "Les biens off-market sont-ils toujours meilleurs ?",
        answer:
          "Non. Un bien off-market n'est interessant que si son prix, sa qualite et ses conditions de transaction sont coherents. La confidentialite ne remplace pas la due diligence.",
      },
    ],
  },
  en: {
    advisoryTitle: "How GADAIT structures your acquisition",
    advisoryIntro:
      "Our role is not to multiply viewings. We qualify the market, remove incoherent assets and build a shortlist that is defensible from a patrimonial, technical and transactional perspective.",
    advisorySteps: [
      "Definition of budget, intended use, tax considerations and desired level of discretion.",
      "Mapping of districts, streets, micro-nuisances and defensible price levels.",
      "Public sourcing, private network access and verification of off-market assets when available.",
      "Comparative analysis, initial due diligence, offer strategy and guidance through completion.",
    ],
    faqTitle: "Frequently asked questions",
    faq: [
      {
        question: "What budget is required for a prime villa in Marbella?",
        answer:
          "Budget depends heavily on the district, beach proximity, plot size, technical condition and address scarcity. Two properties listed at the same price can carry very different risk profiles.",
      },
      {
        question: "Should I buy turnkey or renovate?",
        answer:
          "Turnkey reduces execution risk but often includes a premium. Renovation can create value when land quality, permits, works costs and timing are controlled before the offer.",
      },
      {
        question: "Are off-market properties always better?",
        answer:
          "No. An off-market property is only attractive when price, quality and transaction conditions are coherent. Confidentiality does not replace due diligence.",
      },
    ],
  },
}

const GUIDE_CONTENT = {
  fr: {
    nav: [
      { href: "#micro-zones", label: "Micro-zones" },
      { href: "#distances", label: "Acces" },
      { href: "#budget", label: "Budget" },
      { href: "#comparison", label: "Comparer" },
      { href: "#villa-listings", label: "Villas" },
      { href: "#faq", label: "FAQ" },
    ],
    author: "Analyse GADAIT International",
    updated: "Mis a jour le 11 mai 2026",
    tocTitle: "Guide d'achat",
    microTitle: "Micro-localisations a distinguer avant d'acheter",
    microIntro:
      "Marbella ne se lit pas seulement par nom de quartier. La valeur change selon la rue, l'orientation, le cote plage ou montagne, la proximite des axes routiers, le niveau de securite et la qualite du voisinage immediat.",
    distanceTitle: "Distances utiles pour qualifier l'usage reel",
    distanceIntro:
      "Ces distances sont indicatives. Nous les utilisons comme premier filtre, puis nous verifions l'acces reel, le trafic, la marche possible, les nuisances et le confort quotidien.",
    budgetTitle: "Budget, liquidite et points de negociation",
    budgetIntro:
      "Les fourchettes ci-dessous ne remplacent pas une analyse de comparables. Elles servent a cadrer les attentes avant de comparer les biens disponibles et les opportunites confidentielles.",
    comparisonTitle: "Comparer les secteurs prime de Marbella",
    comparisonIntro:
      "Le bon achat depend rarement d'un seul quartier. Nous comparons chaque secteur selon l'usage, la discretion, la liquidite, le potentiel locatif et les risques techniques.",
    ctaTitle: "Recevoir une lecture privee du secteur",
    ctaText:
      "Nous preparons une shortlist argumentee avec biens publics, alternatives pertinentes et opportunites off-market lorsque le contexte le justifie.",
    ctaButton: "Demander une shortlist privee",
    viewListingsButton: "Comparer les listings disponibles",
    tableLabels: {
      zone: "Zone",
      buyer: "Acheteur cible",
      strength: "Atout",
      risk: "Point a verifier",
      destination: "Destination",
      distance: "Distance approx.",
      drive: "Trajet typique",
      segment: "Segment",
      budget: "Budget indicatif",
      watch: "Lecture GADAIT",
      district: "Secteur",
      bestFor: "Pertinent pour",
      tradeoff: "Arbitrage",
    },
    distances: [
      ["Marbella centre", "3-12 km", "8-18 min"],
      ["Puerto Banus", "2-10 km", "6-18 min"],
      ["Malaga Airport (AGP)", "52-60 km", "35-50 min"],
      ["International schools", "3-18 km", "8-25 min"],
      ["Golf Valley", "2-12 km", "6-20 min"],
      ["Beach clubs / promenade", "0-12 km", "0-20 min"],
    ],
    comparisonRows: [
      ["Golden Mile", "Plage, rarete, lifestyle iconique", "Prix eleve et fortes differences rue par rue"],
      ["Nueva Andalucia", "Famille, golf, usage locatif, profondeur d'offre", "Qualite tres variable selon micro-emplacement"],
      ["Sierra Blanca", "Securite, vues, calme residentiel", "Moins walkable, vigilance acces et entretien"],
      ["La Zagaleta", "Confidentialite, grands terrains, ultra-prime", "Marche peu transparent et cout d'usage eleve"],
    ],
  },
  en: {
    nav: [
      { href: "#micro-zones", label: "Micro-areas" },
      { href: "#distances", label: "Access" },
      { href: "#budget", label: "Budget" },
      { href: "#comparison", label: "Compare" },
      { href: "#villa-listings", label: "Villas" },
      { href: "#faq", label: "FAQ" },
    ],
    author: "GADAIT International analysis",
    updated: "Updated May 11, 2026",
    tocTitle: "Buying guide",
    microTitle: "Micro-locations to separate before buying",
    microIntro:
      "Marbella cannot be read by district name alone. Value changes with the street, orientation, beachside or mountainside position, road exposure, security level and immediate neighbourhood quality.",
    distanceTitle: "Useful distances to qualify real-life use",
    distanceIntro:
      "These distances are indicative. We use them as a first filter, then verify real access, traffic, walkability, nuisance and everyday comfort.",
    budgetTitle: "Budget, liquidity and negotiation points",
    budgetIntro:
      "The ranges below do not replace comparable analysis. They frame expectations before comparing available listings and confidential opportunities.",
    comparisonTitle: "Compare Marbella's prime districts",
    comparisonIntro:
      "The right acquisition rarely depends on one district only. We compare each area by usage, discretion, liquidity, rental potential and technical risk.",
    ctaTitle: "Receive a private read of the district",
    ctaText:
      "We prepare a reasoned shortlist with public listings, relevant alternatives and off-market opportunities when the context justifies it.",
    ctaButton: "Request a private shortlist",
    viewListingsButton: "Compare available listings",
    tableLabels: {
      zone: "Area",
      buyer: "Buyer profile",
      strength: "Strength",
      risk: "Point to verify",
      destination: "Destination",
      distance: "Approx. distance",
      drive: "Typical drive",
      segment: "Segment",
      budget: "Indicative budget",
      watch: "GADAIT read",
      district: "District",
      bestFor: "Best for",
      tradeoff: "Trade-off",
    },
    distances: [
      ["Marbella centre", "3-12 km", "8-18 min"],
      ["Puerto Banus", "2-10 km", "6-18 min"],
      ["Malaga Airport (AGP)", "52-60 km", "35-50 min"],
      ["International schools", "3-18 km", "8-25 min"],
      ["Golf Valley", "2-12 km", "6-20 min"],
      ["Beach clubs / promenade", "0-12 km", "0-20 min"],
    ],
    comparisonRows: [
      ["Golden Mile", "Beach access, scarcity, iconic lifestyle", "High pricing and major street-by-street differences"],
      ["Nueva Andalucia", "Family use, golf, rental depth, inventory depth", "Very uneven quality by micro-location"],
      ["Sierra Blanca", "Security, views, calm residential setting", "Less walkable, access and maintenance need scrutiny"],
      ["La Zagaleta", "Confidentiality, large plots, ultra-prime scale", "Low-transparency market and high running cost"],
    ],
  },
}

const AREA_GUIDE_CONTENT = {
  goldenMile: {
    fr: {
      microZones: [
        ["Beachside / Puente Romano", "Acheteur lifestyle qui veut plage, restaurants et hotels a pied.", "Rareté maximale et demande internationale constante.", "Nuisances, vis-a-vis, surface de parcelle et prime de prix."],
        ["Lomas de Marbella Club / La Carolina", "Famille voulant rester proche de la Golden Mile avec plus de calme.", "Bon compromis entre adresse, acces et surface.", "Orientation, bruit de route et qualite de renovation."],
        ["Nagueles / Rocio de Nagueles", "Acheteur recherchant plus de terrain et une lecture patrimoniale.", "Potentiel de repositionnement et vues selon altitude.", "Limites exactes de l'adresse et couts travaux."],
      ],
      budgetRows: [
        ["Appartement prime", "800 kEUR - 4 MEUR+", "Verifier charges, orientation, qualite de residence et proximite promenade."],
        ["Villa renovee", "4 - 12 MEUR+", "Comparer prix/m2, parcelle utile et niveau reel de finition."],
        ["Beachside rare / signature", "12 - 30 MEUR+", "La liquidite depend de l'unicite, pas seulement du nom Golden Mile."],
      ],
      faq: [
        {
          question: "Ou commence et ou finit la Golden Mile de Marbella ?",
          answer:
            "La Golden Mile n'est pas une zone administrative stricte. Nous la lisons par bandes pratiques: beachside, secteur residentiel entre axes routiers, puis zones en altitude comme Nagueles ou Sierra Blanca selon le contexte.",
        },
        {
          question: "Golden Mile beachside vaut-elle toujours plus cher ?",
          answer:
            "Souvent oui, mais pas automatiquement. Un bien beachside bruyant, mal oriente ou trop expose peut etre moins defendable qu'une villa mieux situee cote residentiel.",
        },
      ],
    },
    en: {
      microZones: [
        ["Beachside / Puente Romano", "Lifestyle buyer wanting beach, restaurants and hotels on foot.", "Maximum scarcity and constant international demand.", "Nuisance, overlooking, plot size and price premium."],
        ["Lomas de Marbella Club / La Carolina", "Family buyer wanting Golden Mile access with a calmer setting.", "Strong balance between address, access and surface area.", "Orientation, road noise and renovation quality."],
        ["Nagueles / Rocio de Nagueles", "Buyer seeking more land and a patrimonial angle.", "Repositioning potential and views depending on elevation.", "Exact address perception and works cost."],
      ],
      budgetRows: [
        ["Prime apartment", "EUR800k - EUR4M+", "Verify fees, orientation, residence quality and promenade proximity."],
        ["Renovated villa", "EUR4M - EUR12M+", "Compare price per sqm, usable plot and real finishing level."],
        ["Rare beachside / signature", "EUR12M - EUR30M+", "Liquidity depends on uniqueness, not only on the Golden Mile name."],
      ],
      faq: [
        {
          question: "Where does Marbella's Golden Mile start and end?",
          answer:
            "The Golden Mile is not a strict administrative area. We read it by practical bands: beachside, residential areas between road corridors, then elevated areas such as Nagueles or Sierra Blanca depending on context.",
        },
        {
          question: "Is Golden Mile beachside always worth more?",
          answer:
            "Often, but not automatically. A noisy, poorly oriented or exposed beachside asset can be less defensible than a better residential villa.",
        },
      ],
    },
  },
  nuevaAndalucia: {
    fr: {
      microZones: [
        ["Aloha / Las Brisas", "Famille et golfeur cherchant calme, club et acces services.", "Demande profonde et rues etablies.", "Vis-a-vis, bruit, renovation superficielle."],
        ["Los Naranjos / Golf Valley", "Acheteur voulant vues golf ou montagne et usage locatif.", "Bon equilibre usage personnel et rendement saisonnier.", "Regles communautaires et gestion locative."],
        ["Proximite Puerto Banus", "Client lifestyle voulant restaurants, marina et sorties rapides.", "Tres forte demande courte duree.", "Nuisance, stationnement et securite immediate."],
      ],
      budgetRows: [
        ["Villa familiale renovee", "2.5 - 6 MEUR", "Comparer plan, jardin plat, chambres et qualite technique."],
        ["Villa golf contemporaine", "4 - 10 MEUR+", "La vue doit etre durable et la renovation defendable."],
        ["Actif a repositionner", "1.8 - 4 MEUR", "Interessant seulement si permis, couts et calendrier sont maitrises."],
      ],
      faq: [
        {
          question: "Nueva Andalucia est-elle adaptee aux familles ?",
          answer:
            "Oui, c'est l'un des secteurs les plus pratiques de Marbella pour les familles: golf, ecoles, restaurants, Puerto Banus et services sont proches, mais il faut choisir les rues avec soin.",
        },
        {
          question: "Nueva Andalucia est-elle meilleure que Golden Mile pour louer ?",
          answer:
            "Elle peut offrir un meilleur equilibre prix d'achat, surface et demande saisonniere. La performance depend toutefois des regles locales, de la gestion et de la qualite exacte du bien.",
        },
      ],
    },
    en: {
      microZones: [
        ["Aloha / Las Brisas", "Family and golf buyer seeking calm, club access and services.", "Deep demand and established streets.", "Overlooking, noise and superficial renovation."],
        ["Los Naranjos / Golf Valley", "Buyer wanting golf or mountain views and rental use.", "Good balance between personal use and seasonal yield.", "Community rules and rental management."],
        ["Puerto Banus proximity", "Lifestyle client wanting restaurants, marina and quick access.", "Very strong short-stay demand.", "Nuisance, parking and immediate security."],
      ],
      budgetRows: [
        ["Renovated family villa", "EUR2.5M - EUR6M", "Compare layout, flat garden, bedroom count and technical quality."],
        ["Contemporary golf villa", "EUR4M - EUR10M+", "The view must be durable and the renovation defensible."],
        ["Repositioning asset", "EUR1.8M - EUR4M", "Attractive only if permits, costs and timing are controlled."],
      ],
      faq: [
        {
          question: "Is Nueva Andalucia suitable for families?",
          answer:
            "Yes. It is one of Marbella's most practical areas for families: golf, schools, restaurants, Puerto Banus and services are close, but street selection matters.",
        },
        {
          question: "Is Nueva Andalucia better than Golden Mile for rentals?",
          answer:
            "It can offer a stronger balance between entry price, surface area and seasonal demand. Performance still depends on local rules, management and exact property quality.",
        },
      ],
    },
  },
  laZagaleta: {
    fr: {
      microZones: [
        ["Secteurs hauts avec vues", "Acheteur ultra-prime recherchant panorama, silence et separation.", "Vues longues et sentiment de domaine prive.", "Vent, acces interne et cout d'entretien."],
        ["Parcelles proches golf", "Famille voulant usage estate, club et activites sur place.", "Lifestyle securise et foncier important.", "Confidentialite reelle et vis-a-vis potentiel."],
        ["Villas anciennes a repositionner", "Acheteur patrimonial capable de piloter un projet long.", "Creation de valeur si la parcelle est exceptionnelle.", "Permis, delais, couts techniques et liquidite de sortie."],
      ],
      budgetRows: [
        ["Villa existante ultra-prime", "8 - 20 MEUR+", "Verifier historique, systemes techniques et coherence avec ventes privees."],
        ["Signature estate", "20 - 50 MEUR+", "La valeur depend de la rarete fonciere, des vues et de l'execution architecturale."],
        ["Projet ou renovation lourde", "Prix au cas par cas", "A analyser comme operation complete: acquisition, travaux, temps, risque et sortie."],
      ],
      faq: [
        {
          question: "La Zagaleta est-elle comparable a Marbella Golden Mile ?",
          answer:
            "Non. Golden Mile est une adresse lifestyle proche plage; La Zagaleta est un domaine prive ultra-prime fonde sur securite, terrain, discretion et vues.",
        },
        {
          question: "Pourquoi les comparables sont-ils difficiles a La Zagaleta ?",
          answer:
            "Une partie des transactions circule hors marche public. Il faut croiser historique discret, qualite de parcelle, cout d'usage et motivation vendeur.",
        },
      ],
    },
    en: {
      microZones: [
        ["Upper view sectors", "Ultra-prime buyer seeking panorama, silence and separation.", "Long views and private-estate feel.", "Wind, internal access and maintenance cost."],
        ["Golf-proximate plots", "Family wanting estate use, club life and on-site activities.", "Secure lifestyle and important land scale.", "Real privacy and possible overlooking."],
        ["Older villas to reposition", "Patrimonial buyer able to manage a long project.", "Value creation if the plot is exceptional.", "Permits, timing, technical costs and exit liquidity."],
      ],
      budgetRows: [
        ["Existing ultra-prime villa", "EUR8M - EUR20M+", "Verify history, technical systems and coherence with private sales."],
        ["Signature estate", "EUR20M - EUR50M+", "Value depends on land rarity, views and architectural execution."],
        ["Project or heavy renovation", "Case by case", "Analyse as a full operation: acquisition, works, time, risk and exit."],
      ],
      faq: [
        {
          question: "Is La Zagaleta comparable with Marbella Golden Mile?",
          answer:
            "No. Golden Mile is a beach-proximate lifestyle address; La Zagaleta is an ultra-prime private estate driven by security, land, discretion and views.",
        },
        {
          question: "Why are comparables difficult in La Zagaleta?",
          answer:
            "Part of the market trades away from public visibility. Discreet history, plot quality, running cost and vendor motivation must be cross-checked.",
        },
      ],
    },
  },
  sierraBlanca: {
    fr: {
      microZones: [
        ["Sierra Blanca core", "Famille internationale recherchant securite et prestige residentiel.", "Adresse forte, vues et calme.", "Prix face a Golden Mile et cout de maintenance."],
        ["Cascada de Camojan", "Acheteur cherchant intimite, architecture et vues plus spectaculaires.", "Rareté, parcelles fortes et topographie interessante.", "Acces, pente, vent et complexite technique."],
        ["Nagueles haut", "Acheteur voulant arbitrer Golden Mile avec plus de terrain.", "Bon pont entre adresse et potentiel patrimonial.", "Perception exacte de la zone et travaux."],
      ],
      budgetRows: [
        ["Villa familiale securisee", "3 - 8 MEUR", "Verifier orientation, volumes utiles et qualite de residence."],
        ["Villa vue mer contemporaine", "6 - 15 MEUR+", "La valeur depend de la protection de vue et de l'execution technique."],
        ["Renovation prime", "2.5 - 6 MEUR", "Interessant si parcelle, vue et adresse justifient le budget total."],
      ],
      faq: [
        {
          question: "Sierra Blanca est-elle une extension de Golden Mile ?",
          answer:
            "Elle est souvent comparee a la Golden Mile haute, mais l'usage est different: plus residentiel, plus securise, moins walkable, avec davantage de vues et de calme.",
        },
        {
          question: "Quels risques verifier a Sierra Blanca ?",
          answer:
            "Orientation, vent, pente, acces, couts de maintenance, charges communautaires et qualite technique sont les points critiques avant offre.",
        },
      ],
    },
    en: {
      microZones: [
        ["Sierra Blanca core", "International family seeking security and residential prestige.", "Strong address, views and calm.", "Pricing versus Golden Mile and maintenance cost."],
        ["Cascada de Camojan", "Buyer seeking privacy, architecture and more dramatic views.", "Rarity, strong plots and interesting topography.", "Access, slope, wind and technical complexity."],
        ["Upper Nagueles", "Buyer comparing Golden Mile with more land.", "Useful bridge between address and patrimonial potential.", "Exact area perception and works."],
      ],
      budgetRows: [
        ["Secure family villa", "EUR3M - EUR8M", "Verify orientation, useful volumes and community quality."],
        ["Contemporary sea-view villa", "EUR6M - EUR15M+", "Value depends on protected views and technical execution."],
        ["Prime renovation", "EUR2.5M - EUR6M", "Attractive if plot, view and address justify the full budget."],
      ],
      faq: [
        {
          question: "Is Sierra Blanca an extension of the Golden Mile?",
          answer:
            "It is often compared with the upper Golden Mile, but usage is different: more residential, more secure, less walkable, with more views and calm.",
        },
        {
          question: "What risks should be verified in Sierra Blanca?",
          answer:
            "Orientation, wind, slope, access, maintenance costs, community fees and technical quality are critical points before an offer.",
        },
      ],
    },
  },
}

const getPageContent = (pageKey, locale) =>
  MARBELLA_AREA_PAGES[pageKey]?.[locale] ||
  MARBELLA_AREA_PAGES[pageKey]?.en ||
  MARBELLA_AREA_PAGES.goldenMile.en

const MarbellaAreaPage = ({ pageKey = "goldenMile", locale = "en" }) => {
  const normalizedLocale = locale === "fr" ? "fr" : "en"
  const content = getPageContent(pageKey, normalizedLocale)
  const visuals = AREA_VISUALS[pageKey] || {
    hero: DEFAULT_HERO_IMAGE,
    heroAlt: {
      fr: content.title,
      en: content.title,
    },
    gallery: [],
  }
  const heroImage = visuals.hero || DEFAULT_HERO_IMAGE
  const heroAlt =
    visuals.heroAlt?.[normalizedLocale] || visuals.heroAlt?.en || content.title
  const visualCards = (visuals.gallery || []).map(card => ({
    ...card,
    ...(card[normalizedLocale] || card.en || {}),
  }))
  const expertContent =
    EXPERT_CONTENT[pageKey]?.[normalizedLocale] ||
    EXPERT_CONTENT[pageKey]?.en ||
    EXPERT_CONTENT.goldenMile.en
  const sharedExpertContent = SHARED_EXPERT_CONTENT[normalizedLocale]
  const guideContent = GUIDE_CONTENT[normalizedLocale]
  const areaGuideContent =
    AREA_GUIDE_CONTENT[pageKey]?.[normalizedLocale] ||
    AREA_GUIDE_CONTENT[pageKey]?.en ||
    AREA_GUIDE_CONTENT.goldenMile.en
  const faqItems = [
    ...(areaGuideContent.faq || []),
    ...(sharedExpertContent.faq || []),
  ]
  const alternateLocale = normalizedLocale === "fr" ? "en" : "fr"
  const alternate = getPageContent(pageKey, alternateLocale)
  const canonicalUrl = `${SITE_URL}/${normalizedLocale}/${content.slug}/`
  const alternateUrl = `${SITE_URL}/${alternateLocale}/${alternate.slug}/`
  const hubPath =
    normalizedLocale === "fr"
      ? "/fr/proprietes-marbella/"
      : "/en/properties-marbella/"
  const villaPath =
    normalizedLocale === "fr"
      ? "/fr/acheter-villa-marbella/"
      : "/en/buy-villa-marbella/"
  const listingsSearchPath =
    normalizedLocale === "fr"
      ? `/fr/recherche/acheter/Marbella/?q=${encodeURIComponent(
          content.listingSearchQuery || "Marbella"
        )}`
      : `/en/search/buy/Marbella/?q=${encodeURIComponent(
          content.listingSearchQuery || "Marbella"
        )}`
  const callPath =
    normalizedLocale === "fr"
      ? "/fr/reserver-un-appel/propriete/"
      : "/en/book-a-call/property/"

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: normalizedLocale === "fr" ? "Accueil" : "Home",
        item: `${SITE_URL}/${normalizedLocale}/`,
      },
      {
        "@type": "ListItem",
        position: 2,
        name:
          normalizedLocale === "fr"
            ? "Proprietes Marbella"
            : "Marbella properties",
        item: `${SITE_URL}${hubPath}`,
      },
      {
        "@type": "ListItem",
        position: 3,
        name: content.title,
        item: canonicalUrl,
      },
    ],
  }
  const articleSchema = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: content.seoTitle,
    description: content.seoDescription,
    image: imageUrl(
      heroImage,
      "auto=compress&fit=crop&fm=jpg&h=630&q=70&w=1200"
    ),
    author: {
      "@type": "Organization",
      name: "GADAIT International",
      url: SITE_URL,
    },
    publisher: {
      "@type": "Organization",
      name: "GADAIT International",
      logo: {
        "@type": "ImageObject",
        url: `${SITE_URL}/logo-gadait.png`,
      },
    },
    dateModified: "2026-05-11",
    mainEntityOfPage: canonicalUrl,
  }
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqItems.map(item => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer,
      },
    })),
  }

  return (
    <Layout
      transparentHeader
      disableStickyHeader
      locale={normalizedLocale}
      // Static href of the language switch (FR/EN slugs differ): without it the
      // header/footer fall back to a naive /fr↔/en swap → 404 for crawlers and cmd-click.
      alternates={[
        { rel: "alternate", hreflang: normalizedLocale, href: canonicalUrl },
        { rel: "alternate", hreflang: alternateLocale, href: alternateUrl },
      ]}
    >
      <Helmet htmlAttributes={{ lang: normalizedLocale }}>
        <title>{content.seoTitle}</title>
        <meta name="description" content={content.seoDescription} />
        <meta
          name="robots"
          content="index, follow, max-snippet:-1, max-image-preview:large"
        />
        <link rel="canonical" href={canonicalUrl} />
        <link rel="alternate" hreflang={normalizedLocale} href={canonicalUrl} />
        <link rel="alternate" hreflang={alternateLocale} href={alternateUrl} />
        <link
          rel="alternate"
          hreflang="x-default"
          href={
            alternateLocale === "en" ? alternateUrl : canonicalUrl
          }
        />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={content.seoTitle} />
        <meta property="og:description" content={content.seoDescription} />
        <meta property="og:url" content={canonicalUrl} />
        <meta
          property="og:image"
          content={imageUrl(heroImage, "w=1200&fit=max&auto=format")}
        />
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>
        <script type="application/ld+json">{JSON.stringify(articleSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      </Helmet>

      <main className="bg-white text-gray-900">
        <section
          data-marbella-area-hero
          className="relative min-h-screen overflow-hidden bg-black text-white"
        >
          <style>{`
            [data-marbella-area-hero] {
              min-height: 100vh;
              height: 100vh;
            }
            @supports (height: 100dvh) {
              [data-marbella-area-hero] {
                min-height: 100dvh;
                height: 100dvh;
              }
            }
          `}</style>
          <img
            src={imageUrl(heroImage, "w=1800&auto=format,compress&q=76")}
            alt={heroAlt}
            className="absolute inset-0 h-full w-full object-cover opacity-58"
            loading="eager"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/56 via-black/24 to-black/88" />
          <div className="absolute inset-x-0 bottom-0 h-[46%] bg-gradient-to-t from-black/74 via-black/36 to-transparent" />
          <div className="container relative z-10 flex h-full flex-col justify-end pb-20 pt-32 md:pb-28 lg:pb-32">
            <p className="mb-4 text-[10px] font-medium uppercase tracking-[0.32em] text-white/72 md:text-[11px]">
              {content.eyebrow}
            </p>
            <h1 className="max-w-4xl text-5xl font-light leading-[1] tracking-[-0.03em] md:text-6xl">
              {content.title}
            </h1>
            <p className="mt-5 max-w-2xl text-base leading-7 text-white/82 md:text-lg md:leading-8">
              {content.intro}
            </p>
            <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
              <Link
                to={callPath}
                className="inline-flex h-12 items-center justify-center rounded-full bg-white px-6 text-[12px] font-semibold uppercase tracking-[0.18em] text-gray-950 shadow-[0_16px_34px_rgba(0,0,0,0.2)] transition hover:bg-gray-100"
              >
                {content.cta}
              </Link>
              <Link
                to={villaPath}
                className="inline-flex h-12 items-center justify-center rounded-full border border-white/30 bg-white/[0.03] px-6 text-[12px] font-medium uppercase tracking-[0.18em] text-white/86 backdrop-blur-sm transition hover:border-white/60 hover:text-white"
              >
                {content.searchLabel}
              </Link>
            </div>
          </div>
        </section>

        {visualCards.length > 0 && (
          <section className="bg-white">
            <div className="container py-8 md:py-14">
              <div className="grid h-[280px] grid-cols-3 gap-2 overflow-hidden rounded-[28px] bg-gray-100 md:h-[430px] md:gap-3">
                {visualCards.slice(0, 3).map((card, index) => (
                  <div key={`${pageKey}-visual-${index}`} className="overflow-hidden">
                    <img
                      src={imageUrl(
                        card.image,
                        "w=980&h=980&fit=crop&auto=format,compress&q=74"
                      )}
                      alt={card.title}
                      title={card.title}
                      className="h-full w-full object-cover transition duration-700 hover:scale-[1.04]"
                      loading="lazy"
                    />
                  </div>
                ))}
              </div>

              <div className="mt-8 grid gap-px overflow-hidden rounded-2xl bg-gray-100 md:grid-cols-3">
                {visualCards.slice(0, 3).map((card, index) => (
                  <article
                    key={`${pageKey}-visual-caption-${index}`}
                    className="bg-white px-6 py-6 md:px-7 md:py-7"
                  >
                    <p className="text-[10px] font-medium uppercase tracking-[0.24em] text-gray-400">
                      {card.eyebrow}
                    </p>
                    <h2 className="mt-3 text-xl font-light tracking-[-0.02em] text-gray-950 md:text-2xl">
                      {card.title}
                    </h2>
                    <p className="mt-3 text-sm leading-6 text-gray-600">
                      {card.text}
                    </p>
                  </article>
                ))}
              </div>
            </div>
          </section>
        )}

        <section className="sticky top-0 z-20 border-b border-gray-200 bg-white/92 backdrop-blur-xl">
          <div className="container flex flex-col gap-3 py-4 lg:flex-row lg:items-center lg:justify-between">
            <div>
              <p className="text-[10px] font-medium uppercase tracking-[0.22em] text-gray-400">
                {guideContent.author}
              </p>
              <p className="mt-1 text-sm text-gray-600">{guideContent.updated}</p>
            </div>
            <nav
              aria-label={guideContent.tocTitle}
              className="flex gap-2 overflow-x-auto pb-1 lg:pb-0"
            >
              {guideContent.nav.map(item => (
                <a
                  key={item.href}
                  href={item.href}
                  className="shrink-0 rounded-full border border-gray-200 px-4 py-2 text-[12px] font-medium text-gray-700 transition hover:border-gray-950 hover:text-gray-950"
                >
                  {item.label}
                </a>
              ))}
            </nav>
          </div>
        </section>

        <section className="border-b border-gray-100 bg-white">
          <div className="container grid gap-10 py-16 md:grid-cols-[0.9fr_1.1fr] md:py-24">
            <div>
              <p className="text-[11px] font-medium uppercase tracking-[0.24em] text-gray-400">
                {normalizedLocale === "fr" ? "Lecture marche" : "Market lens"}
              </p>
              <h2 className="mt-4 text-3xl font-light leading-tight tracking-[-0.02em] text-gray-950 md:text-4xl">
                {content.sections[0].title}
              </h2>
              <p className="mt-5 text-[15px] leading-relaxed text-gray-600">
                {content.sections[0].text}
              </p>
            </div>
            <div className="grid gap-3 sm:grid-cols-2">
              {content.bullets.map(item => (
                <div
                  key={item}
                  className="rounded-2xl border border-gray-100 bg-gray-50 px-5 py-5"
                >
                  <p className="text-sm font-medium text-gray-900">{item}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="bg-[#f5f5f7]">
          <div className="container grid gap-8 py-16 md:grid-cols-2 md:py-20">
            {content.sections.slice(1).map(section => (
              <article
                key={section.title}
                className="rounded-3xl bg-white p-8 shadow-sm"
              >
                <h2 className="text-2xl font-light tracking-[-0.02em] text-gray-950">
                  {section.title}
                </h2>
                <p className="mt-4 text-[15px] leading-relaxed text-gray-600">
                  {section.text}
                </p>
              </article>
            ))}
            <article className="rounded-3xl bg-[#0f0f0f] p-8 text-white">
              <h2 className="text-2xl font-light tracking-[-0.02em]">
                {normalizedLocale === "fr"
                  ? "Selection confidentielle"
                  : "Confidential shortlist"}
              </h2>
              <p className="mt-4 text-[15px] leading-relaxed text-white/68">
                {normalizedLocale === "fr"
                  ? "Partagez votre budget, votre horizon et votre usage. Nous revenons avec une lecture claire du secteur et les actifs les plus coherents, y compris off-market si pertinent."
                  : "Share your budget, timing and intended use. We respond with a clear read of the district and the most coherent assets, including off-market options when relevant."}
              </p>
              <Link
                to={callPath}
                className="mt-6 inline-flex rounded-full bg-white px-5 py-3 text-sm font-medium text-gray-950"
              >
                {content.cta}
              </Link>
            </article>
          </div>
        </section>

        <section id="micro-zones" className="bg-white">
          <div className="container py-16 md:py-24">
            <div className="max-w-3xl">
              <p className="text-[11px] font-medium uppercase tracking-[0.24em] text-gray-400">
                {guideContent.tocTitle}
              </p>
              <h2 className="mt-4 text-3xl font-light tracking-[-0.02em] text-gray-950 md:text-4xl">
                {guideContent.microTitle}
              </h2>
              <p className="mt-5 text-[16px] leading-8 text-gray-600">
                {guideContent.microIntro}
              </p>
            </div>
            <div className="mt-10 overflow-hidden rounded-2xl border border-gray-200 bg-white">
              <div className="overflow-x-auto">
                <table className="min-w-[760px] w-full border-collapse text-left">
                  <thead className="bg-gray-950 text-white">
                    <tr>
                      <th className="px-5 py-4 text-[11px] font-medium uppercase tracking-[0.18em]">
                        {guideContent.tableLabels.zone}
                      </th>
                      <th className="px-5 py-4 text-[11px] font-medium uppercase tracking-[0.18em]">
                        {guideContent.tableLabels.buyer}
                      </th>
                      <th className="px-5 py-4 text-[11px] font-medium uppercase tracking-[0.18em]">
                        {guideContent.tableLabels.strength}
                      </th>
                      <th className="px-5 py-4 text-[11px] font-medium uppercase tracking-[0.18em]">
                        {guideContent.tableLabels.risk}
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100">
                    {areaGuideContent.microZones.map(row => (
                      <tr key={row[0]} className="align-top">
                        {row.map((cell, index) => (
                          <td
                            key={`${row[0]}-${index}`}
                            className={`px-5 py-5 text-sm leading-6 ${
                              index === 0
                                ? "font-medium text-gray-950"
                                : "text-gray-600"
                            }`}
                          >
                            {cell}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>

        <section id="distances" className="border-y border-gray-100 bg-[#f7f7f8]">
          <div className="container grid gap-10 py-16 lg:grid-cols-[0.85fr_1.15fr] lg:py-24">
            <div>
              <p className="text-[11px] font-medium uppercase tracking-[0.24em] text-gray-400">
                Access
              </p>
              <h2 className="mt-4 text-3xl font-light tracking-[-0.02em] text-gray-950 md:text-4xl">
                {guideContent.distanceTitle}
              </h2>
              <p className="mt-5 text-[15px] leading-7 text-gray-600">
                {guideContent.distanceIntro}
              </p>
            </div>
            <div className="grid gap-3 sm:grid-cols-2">
              {guideContent.distances.map(row => (
                <article
                  key={row[0]}
                  className="rounded-2xl bg-white p-5 shadow-sm ring-1 ring-black/5"
                >
                  <h3 className="text-base font-medium text-gray-950">
                    {row[0]}
                  </h3>
                  <p className="mt-3 text-sm text-gray-500">
                    {guideContent.tableLabels.distance}:{" "}
                    <span className="font-medium text-gray-800">{row[1]}</span>
                  </p>
                  <p className="mt-1 text-sm text-gray-500">
                    {guideContent.tableLabels.drive}:{" "}
                    <span className="font-medium text-gray-800">{row[2]}</span>
                  </p>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section id="budget" className="bg-white">
          <div className="container py-16 md:py-24">
            <div className="grid gap-8 lg:grid-cols-[0.7fr_1.3fr]">
              <div>
                <p className="text-[11px] font-medium uppercase tracking-[0.24em] text-gray-400">
                  Pricing
                </p>
                <h2 className="mt-4 text-3xl font-light tracking-[-0.02em] text-gray-950 md:text-4xl">
                  {guideContent.budgetTitle}
                </h2>
                <p className="mt-5 text-[15px] leading-7 text-gray-600">
                  {guideContent.budgetIntro}
                </p>
              </div>
              <div className="overflow-hidden rounded-2xl border border-gray-200">
                <div className="overflow-x-auto">
                  <table className="min-w-[680px] w-full border-collapse text-left">
                    <thead className="bg-[#0f172a] text-white">
                      <tr>
                        <th className="px-5 py-4 text-[11px] font-medium uppercase tracking-[0.18em]">
                          {guideContent.tableLabels.segment}
                        </th>
                        <th className="px-5 py-4 text-[11px] font-medium uppercase tracking-[0.18em]">
                          {guideContent.tableLabels.budget}
                        </th>
                        <th className="px-5 py-4 text-[11px] font-medium uppercase tracking-[0.18em]">
                          {guideContent.tableLabels.watch}
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100 bg-white">
                      {areaGuideContent.budgetRows.map(row => (
                        <tr key={row[0]} className="align-top">
                          <td className="px-5 py-5 text-sm font-medium text-gray-950">
                            {row[0]}
                          </td>
                          <td className="px-5 py-5 text-sm text-gray-700">
                            {row[1]}
                          </td>
                          <td className="px-5 py-5 text-sm leading-6 text-gray-600">
                            {row[2]}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="comparison" className="bg-[#111827] text-white">
          <div className="container py-16 md:py-24">
            <div className="grid gap-10 lg:grid-cols-[0.8fr_1.2fr]">
              <div>
                <p className="text-[11px] font-medium uppercase tracking-[0.24em] text-white/45">
                  Marbella prime
                </p>
                <h2 className="mt-4 text-3xl font-light tracking-[-0.02em] md:text-4xl">
                  {guideContent.comparisonTitle}
                </h2>
                <p className="mt-5 text-[15px] leading-7 text-white/68">
                  {guideContent.comparisonIntro}
                </p>
              </div>
              <div className="grid gap-3">
                {guideContent.comparisonRows.map(row => (
                  <article
                    key={row[0]}
                    className="grid gap-4 rounded-2xl border border-white/10 bg-white/[0.04] p-5 md:grid-cols-[0.45fr_0.8fr_0.85fr]"
                  >
                    <h3 className="text-base font-medium text-white">{row[0]}</h3>
                    <p className="text-sm leading-6 text-white/70">
                      <span className="text-white/38">
                        {guideContent.tableLabels.bestFor}:{" "}
                      </span>
                      {row[1]}
                    </p>
                    <p className="text-sm leading-6 text-white/70">
                      <span className="text-white/38">
                        {guideContent.tableLabels.tradeoff}:{" "}
                      </span>
                      {row[2]}
                    </p>
                  </article>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="bg-white">
          <div className="container py-12">
            <div className="grid gap-6 rounded-3xl border border-gray-200 bg-[#f7f7f8] p-8 md:grid-cols-[1fr_auto] md:items-center">
              <div>
                <h2 className="text-2xl font-light tracking-[-0.02em] text-gray-950">
                  {guideContent.ctaTitle}
                </h2>
                <p className="mt-3 max-w-2xl text-[15px] leading-7 text-gray-600">
                  {guideContent.ctaText}
                </p>
              </div>
              <div className="flex flex-col gap-3 sm:flex-row md:flex-col">
                <Link
                  to={callPath}
                  className="inline-flex justify-center rounded-full bg-gray-950 px-6 py-3 text-sm font-medium text-white"
                >
                  {guideContent.ctaButton}
                </Link>
                <Link
                  to={listingsSearchPath}
                  className="inline-flex justify-center rounded-full border border-gray-300 bg-white px-6 py-3 text-sm font-medium text-gray-950"
                >
                  {guideContent.viewListingsButton}
                </Link>
              </div>
            </div>
          </div>
        </section>

        <div id="villa-listings">
          <DestinationListingsPreview
            locale={normalizedLocale}
            cityFacet="Marbella"
            locationKeywords={content.listingKeywords || []}
            searchPath={listingsSearchPath}
            perPage={9}
            title={content.listingTitle}
            intro={content.listingIntro}
            viewAllLabelOverride={content.allListingsLabel}
          />
        </div>

        <section className="bg-white">
          <div className="container grid gap-12 py-16 md:grid-cols-[0.8fr_1.2fr] md:py-24">
            <div>
              <p className="text-[11px] font-medium uppercase tracking-[0.24em] text-gray-400">
                {normalizedLocale === "fr"
                  ? "Positionnement"
                  : "Positioning"}
              </p>
              <h2 className="mt-4 text-3xl font-light leading-tight tracking-[-0.02em] text-gray-950 md:text-4xl">
                {normalizedLocale === "fr"
                  ? "Lire le marche avant de visiter"
                  : "Read the market before viewing"}
              </h2>
            </div>
            <p className="text-[17px] leading-[1.8] text-gray-600">
              {expertContent.positioning}
            </p>
          </div>
        </section>

        <section className="border-y border-gray-100 bg-[#f7f7f8]">
          <div className="container py-16 md:py-24">
            <div className="max-w-3xl">
              <p className="text-[11px] font-medium uppercase tracking-[0.24em] text-gray-400">
                {normalizedLocale === "fr"
                  ? "Signaux de marche"
                  : "Market signals"}
              </p>
              <h2 className="mt-4 text-3xl font-light tracking-[-0.02em] text-gray-950 md:text-4xl">
                {normalizedLocale === "fr"
                  ? "Ce qui fait vraiment la valeur"
                  : "What really drives value"}
              </h2>
            </div>
            <div className="mt-10 grid gap-4 md:grid-cols-3">
              {expertContent.marketSignals.map(signal => (
                <article
                  key={signal.label}
                  className="rounded-2xl bg-white p-6 shadow-sm ring-1 ring-black/5"
                >
                  <h3 className="text-lg font-medium text-gray-950">
                    {signal.label}
                  </h3>
                  <p className="mt-3 text-sm leading-6 text-gray-600">
                    {signal.text}
                  </p>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="bg-white">
          <div className="container grid gap-8 py-16 lg:grid-cols-3 lg:py-24">
            <article className="lg:col-span-1">
              <p className="text-[11px] font-medium uppercase tracking-[0.24em] text-gray-400">
                {normalizedLocale === "fr"
                  ? "Acheteurs"
                  : "Buyer profiles"}
              </p>
              <h2 className="mt-4 text-3xl font-light tracking-[-0.02em] text-gray-950">
                {normalizedLocale === "fr"
                  ? "Pour qui ce secteur est pertinent"
                  : "Who this district suits"}
              </h2>
            </article>
            <div className="grid gap-3 lg:col-span-2">
              {expertContent.buyerProfiles.map(item => (
                <div
                  key={item}
                  className="rounded-2xl border border-gray-100 px-6 py-5"
                >
                  <p className="text-[15px] leading-7 text-gray-700">{item}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="bg-[#101010] text-white">
          <div className="container grid gap-12 py-16 lg:grid-cols-2 lg:py-24">
            <div>
              <p className="text-[11px] font-medium uppercase tracking-[0.24em] text-white/45">
                {normalizedLocale === "fr"
                  ? "Typologies"
                  : "Property types"}
              </p>
              <h2 className="mt-4 text-3xl font-light tracking-[-0.02em] md:text-4xl">
                {normalizedLocale === "fr"
                  ? "Les actifs a comparer"
                  : "Assets to compare"}
              </h2>
              <div className="mt-8 space-y-4">
                {expertContent.propertyTypes.map(item => (
                  <p key={item} className="text-[15px] leading-7 text-white/70">
                    {item}
                  </p>
                ))}
              </div>
            </div>
            <div>
              <p className="text-[11px] font-medium uppercase tracking-[0.24em] text-white/45">
                Due diligence
              </p>
              <h2 className="mt-4 text-3xl font-light tracking-[-0.02em] md:text-4xl">
                {normalizedLocale === "fr"
                  ? "Ce que nous validons avant offre"
                  : "What we validate before an offer"}
              </h2>
              <div className="mt-8 grid gap-3">
                {expertContent.dueDiligence.map(item => (
                  <div
                    key={item}
                    className="rounded-2xl border border-white/10 bg-white/[0.04] px-5 py-4"
                  >
                    <p className="text-sm leading-6 text-white/76">{item}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="bg-white">
          <div className="container grid gap-10 py-16 md:grid-cols-[0.85fr_1.15fr] md:py-24">
            <div>
              <p className="text-[11px] font-medium uppercase tracking-[0.24em] text-gray-400">
                Advisory
              </p>
              <h2 className="mt-4 text-3xl font-light tracking-[-0.02em] text-gray-950 md:text-4xl">
                {sharedExpertContent.advisoryTitle}
              </h2>
              <p className="mt-5 text-[15px] leading-7 text-gray-600">
                {sharedExpertContent.advisoryIntro}
              </p>
            </div>
            <ol className="space-y-4">
              {sharedExpertContent.advisorySteps.map((step, index) => (
                <li
                  key={step}
                  className="grid grid-cols-[44px_1fr] gap-4 rounded-2xl border border-gray-100 p-5"
                >
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-gray-950 text-sm font-medium text-white">
                    {index + 1}
                  </span>
                  <p className="self-center text-[15px] leading-7 text-gray-700">
                    {step}
                  </p>
                </li>
              ))}
            </ol>
          </div>
        </section>

        <section id="faq" className="border-t border-gray-100 bg-[#f7f7f8]">
          <div className="container py-16 md:py-24">
            <h2 className="text-3xl font-light tracking-[-0.02em] text-gray-950 md:text-4xl">
              {sharedExpertContent.faqTitle}
            </h2>
            <div className="mt-8 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
              {faqItems.map(item => (
                <article key={item.question} className="rounded-2xl bg-white p-6">
                  <h3 className="text-base font-medium text-gray-950">
                    {item.question}
                  </h3>
                  <p className="mt-3 text-sm leading-6 text-gray-600">
                    {item.answer}
                  </p>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="bg-white">
          <div className="container flex flex-col gap-4 py-12 sm:flex-row">
            <Link
              to={hubPath}
              className="inline-flex rounded-full border border-gray-300 px-5 py-3 text-sm font-medium text-gray-900"
            >
              {content.hubLabel}
            </Link>
            <Link
              to={villaPath}
              className="inline-flex rounded-full bg-[#0071e3] px-5 py-3 text-sm font-medium text-white"
            >
              {content.searchLabel}
            </Link>
          </div>
        </section>
      </main>
    </Layout>
  )
}

export default MarbellaAreaPage
